export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/internalcontrol/purchase/detail',
      method: 'GET'
    }]
  }
}